import React from "react";

import { Popover as AntPopover, PopoverProps as AntPopoverProps } from "antd";

// ----------------------------
// ------- use Modal for functional things - this is only for informational items
// ----------------------------

type PopoverProps = AntPopoverProps & {
  dataTestId?: string;
};
export const Popover = ({ className, visible, children, dataTestId, ...props }: PopoverProps) => (
  <AntPopover overlayClassName={className} open={visible} data-testid={dataTestId} {...props}>
    {children}
  </AntPopover>
);

export default Popover;
